var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { getScrollbarStyles } from '../../scrollbar/styles/getScrollbarStyles';
// Types
import styled, { css } from 'styled-components';
export var Container = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  // background\n  background: ", ";\n  background-color: ", ";\n  background-image: ", ";\n\n  // border\n  border: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  border-top-left-radius: ", ";\n  border-bottom-left-radius: ", ";\n\n  // outline\n  outline: ", ";\n\n  // colors and effects\n  color: ", ";\n  opacity: ", ";\n  box-shadow: ", ";\n  box-sizing: ", ";\n\n  // cursor\n  cursor: ", ";\n  pointer-events: ", ";\n\n  // text\n  color: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  text-indent: ", ";\n  white-space: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n\n  // display\n  display: ", ";\n\n  // flex\n  flex: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n\n  // grid\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n  grid-column: ", ";\n  grid-row: ", ";\n\n  // alignments\n  align-items: ", ";\n  align-content: ", ";\n  float: ", ";\n  justify-content: ", ";\n  justify-self: ", ";\n  align-self: ", ";\n  place-self: ", ";\n\n  // dimensions\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  line-height: ", ";\n\n  // margins and paddings\n  margin: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  padding: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n\n  // overflow\n  overflow: ", ";\n  overflow-x: ", ";\n  overflow-y: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  word-break: ", ";\n\n  // positions\n  position: ", ";\n  bottom: ", ";\n  right: ", ";\n  top: ", ";\n  left: ", ";\n  z-index: ", ";\n\n  // Transform\n  transform: ", ";\n\n  // Scrollbar\n  ", "\n\n  // psuedo-classes\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  // background\n  background: ", ";\n  background-color: ", ";\n  background-image: ", ";\n\n  // border\n  border: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  border-top-left-radius: ",
    ";\n  border-bottom-left-radius: ",
    ";\n\n  // outline\n  outline: ", ";\n\n  // colors and effects\n  color: ", ";\n  opacity: ", ";\n  box-shadow: ", ";\n  box-sizing: ", ";\n\n  // cursor\n  cursor: ", ";\n  pointer-events: ", ";\n\n  // text\n  color: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  text-indent: ", ";\n  white-space: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n\n  // display\n  display: ", ";\n\n  // flex\n  flex: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n\n  // grid\n  grid-template-columns: ",
    ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n  grid-column: ", ";\n  grid-row: ", ";\n\n  // alignments\n  align-items: ", ";\n  align-content: ", ";\n  float: ", ";\n  justify-content: ", ";\n  justify-self: ", ";\n  align-self: ", ";\n  place-self: ", ";\n\n  // dimensions\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  line-height: ", ";\n\n  // margins and paddings\n  margin: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  padding: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n\n  // overflow\n  overflow: ", ";\n  overflow-x: ", ";\n  overflow-y: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  word-break: ", ";\n\n  // positions\n  position: ", ";\n  bottom: ", ";\n  right: ", ";\n  top: ", ";\n  left: ", ";\n  z-index: ", ";\n\n  // Transform\n  transform: ", ";\n\n  // Scrollbar\n  ", "\n\n  // psuedo-classes\n  ", "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (_a) {
    var background = _a.background;
    return background || null;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return "" + backgroundColor || null;
}, function (_a) {
    var backgroundImage = _a.backgroundImage;
    return (backgroundImage ? "" + backgroundImage : null);
}, function (_a) {
    var border = _a.border;
    return (border ? "" + border : null);
}, function (_a) {
    var borderColor = _a.borderColor;
    return (borderColor ? "" + borderColor : null);
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return (borderRadius ? "" + borderRadius : null);
}, function (_a) {
    var borderTop = _a.borderTop;
    return (borderTop ? "" + borderTop : null);
}, function (_a) {
    var borderBottom = _a.borderBottom;
    return (borderBottom ? "" + borderBottom : null);
}, function (_a) {
    var borderLeft = _a.borderLeft;
    return (borderLeft ? "" + borderLeft : null);
}, function (_a) {
    var borderRight = _a.borderRight;
    return (borderRight ? "" + borderRight : null);
}, function (_a) {
    var borderTopLeftRadius = _a.borderTopLeftRadius;
    return borderTopLeftRadius ? "" + borderTopLeftRadius : null;
}, function (_a) {
    var borderBottomLeftRadius = _a.borderBottomLeftRadius;
    return borderBottomLeftRadius ? "" + borderBottomLeftRadius : null;
}, function (_a) {
    var outline = _a.outline;
    return (outline ? "" + outline : null);
}, function (_a) {
    var color = _a.color;
    return (color ? "" + color : null);
}, function (_a) {
    var opacity = _a.opacity;
    return (opacity ? "" + opacity : 1);
}, function (_a) {
    var boxShadow = _a.boxShadow;
    return (boxShadow ? "" + boxShadow : null);
}, function (_a) {
    var boxSizing = _a.boxSizing;
    return (boxSizing ? "" + boxSizing : null);
}, function (_a) {
    var cursor = _a.cursor;
    return (cursor ? "" + cursor : null);
}, function (_a) {
    var pointerEvents = _a.pointerEvents;
    return (pointerEvents ? "" + pointerEvents : null);
}, function (_a) {
    var color = _a.color;
    return (color ? "" + color : null);
}, function (_a) {
    var fontSize = _a.fontSize;
    return (fontSize ? "" + fontSize : '11px');
}, function (_a) {
    var fontStyle = _a.fontStyle;
    return (fontStyle ? "" + fontStyle : 'normal');
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return (fontWeight ? "" + fontWeight : null);
}, function (_a) {
    var textAlign = _a.textAlign;
    return (textAlign ? "" + textAlign : null);
}, function (_a) {
    var textIndent = _a.textIndent;
    return (textIndent ? "" + textIndent : null);
}, function (_a) {
    var whiteSpace = _a.whiteSpace;
    return (whiteSpace ? "" + whiteSpace : null);
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return (fontFamily ? "" + fontFamily : null);
}, function (_a) {
    var letterSpacing = _a.letterSpacing;
    return (letterSpacing ? "" + letterSpacing : null);
}, function (_a) {
    var display = _a.display;
    return (display ? "" + display : 'initial');
}, function (_a) {
    var flex = _a.flex;
    return (flex ? "" + flex : null);
}, function (_a) {
    var flexDirection = _a.flexDirection;
    return (flexDirection ? "" + flexDirection : null);
}, function (_a) {
    var flexWrap = _a.flexWrap;
    return (flexWrap ? "" + flexWrap : null);
}, function (_a) {
    var gridTemplateColumns = _a.gridTemplateColumns;
    return gridTemplateColumns ? "" + gridTemplateColumns : 'initial';
}, function (_a) {
    var gridTemplateRows = _a.gridTemplateRows;
    return (gridTemplateRows ? "" + gridTemplateRows : 'initial');
}, function (_a) {
    var gridColumnGap = _a.gridColumnGap;
    return (gridColumnGap ? "" + gridColumnGap : null);
}, function (_a) {
    var gridRowGap = _a.gridRowGap;
    return (gridRowGap ? "" + gridRowGap : null);
}, function (_a) {
    var gridColumn = _a.gridColumn;
    return (gridColumn ? "" + gridColumn : null);
}, function (_a) {
    var gridRow = _a.gridRow;
    return (gridRow ? "" + gridRow : null);
}, function (_a) {
    var alignItems = _a.alignItems;
    return (alignItems ? "" + alignItems : null);
}, function (_a) {
    var alignContent = _a.alignContent;
    return alignContent !== null && alignContent !== void 0 ? alignContent : null;
}, function (_a) {
    var float = _a.float;
    return (float ? "" + float : null);
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return (justifyContent ? "" + justifyContent : null);
}, function (_a) {
    var justifySelf = _a.justifySelf;
    return (justifySelf ? "" + justifySelf : null);
}, function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf !== null && alignSelf !== void 0 ? alignSelf : null;
}, function (_a) {
    var placeSelf = _a.placeSelf;
    return (placeSelf ? "" + placeSelf : null);
}, function (_a) {
    var height = _a.height;
    return (height ? "" + height : null);
}, function (_a) {
    var minHeight = _a.minHeight;
    return (minHeight ? "" + minHeight : null);
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return (maxHeight ? "" + maxHeight : null);
}, function (_a) {
    var width = _a.width;
    return (width ? "" + width : null);
}, function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? "" + minWidth : null);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "" + maxWidth : null);
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return (lineHeight ? "" + lineHeight : '16px');
}, function (_a) {
    var margin = _a.margin;
    return (margin ? "" + margin : null);
}, function (_a) {
    var marginRight = _a.marginRight;
    return (marginRight ? "" + marginRight : null);
}, function (_a) {
    var marginLeft = _a.marginLeft;
    return (marginLeft ? "" + marginLeft : null);
}, function (_a) {
    var marginTop = _a.marginTop;
    return (marginTop ? "" + marginTop : null);
}, function (_a) {
    var marginBottom = _a.marginBottom;
    return (marginBottom ? "" + marginBottom : null);
}, function (_a) {
    var padding = _a.padding;
    return (padding ? "" + padding : 0);
}, function (_a) {
    var paddingLeft = _a.paddingLeft;
    return (paddingLeft ? "" + paddingLeft : null);
}, function (_a) {
    var paddingTop = _a.paddingTop;
    return (paddingTop ? "" + paddingTop : null);
}, function (_a) {
    var overflow = _a.overflow;
    return (overflow ? "" + overflow : null);
}, function (_a) {
    var overflowX = _a.overflowX;
    return (overflowX ? "" + overflowX : null);
}, function (_a) {
    var overflowY = _a.overflowY;
    return (overflowY ? "" + overflowY : null);
}, function (_a) {
    var webkitLineClamp = _a.webkitLineClamp;
    return (webkitLineClamp ? "" + webkitLineClamp : null);
}, function (_a) {
    var webkitBoxOrient = _a.webkitBoxOrient;
    return (webkitBoxOrient ? "" + webkitBoxOrient : null);
}, function (_a) {
    var wordBreak = _a.wordBreak;
    return (wordBreak ? "" + wordBreak : null);
}, function (_a) {
    var position = _a.position;
    return (position ? "" + position : null);
}, function (_a) {
    var bottom = _a.bottom;
    return (bottom ? "" + bottom : null);
}, function (_a) {
    var right = _a.right;
    return (right ? "" + right : null);
}, function (_a) {
    var top = _a.top;
    return (top ? "" + top : null);
}, function (_a) {
    var left = _a.left;
    return (left ? "" + left : null);
}, function (_a) {
    var zIndex = _a.zIndex;
    return (zIndex ? "" + zIndex : null);
}, function (_a) {
    var transform = _a.transform;
    return (transform ? "" + transform : null);
}, function (_a) {
    var theme = _a.theme, scrollbarSize = _a.scrollbarSize;
    return getScrollbarStyles(theme, scrollbarSize);
}, function (_a) {
    var lastOfTypeNoMargin = _a.lastOfTypeNoMargin;
    return (lastOfTypeNoMargin ? 'div:last-of-type { margin-bottom: 0; }' : '');
}, function (_a) {
    var borderedOnFocus = _a.borderedOnFocus;
    if (borderedOnFocus) {
        var border = borderedOnFocus.border, borderRadius = borderedOnFocus.borderRadius;
        return "&:focus {border: " + (border || 'none') + "; border-radius: " + (borderRadius || 0) + " }";
    }
    return null;
}, function (_a) {
    var firstChild = _a.firstChild;
    return firstChild && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:first-child {\n        ", "\n      }\n    "], ["\n      &:first-child {\n        ", "\n      }\n    "])), firstChild);
}, function (_a) {
    var hoverEffects = _a.hoverEffects;
    return hoverEffects && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:hover {\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n      }\n    "])), hoverEffects);
}, function (_a) {
    var activeEffects = _a.activeEffects;
    return activeEffects && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:active {\n        ", "\n      }\n    "], ["\n      &:active {\n        ", "\n      }\n    "])), activeEffects);
}, function (_a) {
    var focusWithinEffects = _a.focusWithinEffects;
    return focusWithinEffects && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:focus-within {\n        ", "\n      }\n    "], ["\n      &:focus-within {\n        ", "\n      }\n    "])), focusWithinEffects);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Container.js.map